import React, { useEffect, useState } from "react";
import { Button, Alert, Spinner } from "react-bootstrap";
import "../../assets/scss/custom-colors.scss";
import { getUserProfile } from "../../Common/data/getUserProfile";

const TestTab = () => {
    const [bioDataStatus, setBioDataStatus] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const userData = await getUserProfile();
                setBioDataStatus(userData.results.bioDataStatus); // Assuming bioDataStatus is in results
            } catch (error: any) {
                console.error("Error fetching user profile:", error.message);
                setErrorMessage("Error fetching user profile");
            } finally {
                setLoading(false);
            }
        };

        fetchUserProfile();
    }, []);

    if (loading) {
        return <Spinner animation="border" variant="primary" />;
    }

    return (
        <>
            <h5 className="mb-4 custom-text-primary">Take Your Test</h5>
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            {bioDataStatus === "pending" ? (
                <Alert variant="warning">
                    You are not eligible to take the test yet until you get approval for your bio data.
                </Alert>
            ) : (
                <Alert variant="info">
                    Please log in using your already existing username and password.
                </Alert>
            )}
            {bioDataStatus !== "pending" && (
                <div className="text-center mt-4">
                    <Button 
                        variant="primary" 
                        href="https://candidate.speedexam.net/signin.aspx?site=atcef" 
                        target="_blank"
                        className="custom-secondary-btn"
                    >
                        Take Test
                    </Button>
                </div>
            )}
        </>
    );
};

export default TestTab;
